export enum WorkflowErrorType {
    None,
    MessageCenter
}
